export const environment = {
  production: true,
  development: false,
  test: false,
  url: 'https://lorealeventy-pl.beauty-campaigns.com',
  api: 'https://lorealeventy-pl.beauty-campaigns.com/api',
  recaptchaV3SiteKey: '6Le7PgUrAAAAAFmZTgWnml78mer_VPpeGUucfwkG',
  oneScriptDataDomainKey: '0194898b-6740-70a3-9632-56c82258f092',
  flowPlayerPlayerId: 'b661fd46-eeac-4f1d-9a2d-0b1a6bfac2fd',
  flowPlayerToken:
    'eyJraWQiOiJxV3FyRWFmQXV1UjUiLCJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjIjoie1wiYWNsXCI6NixcImlkXCI6XCJxV3FyRWFmQXV1UjVcIn0iLCJpc3MiOiJGbG93cGxheWVyIn0.Aup4eNhtBC-Ffn5EvFzoBdxFTCx14odRjkEtcss3ldCpo2JMbeD5Sv4P-IuMXRbmiA2a_TbJcZCqTZJKR4TPTQ',
};
